module.exports = __webpack_public_path__ + "img/product3.f78042ed.png";